var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Router } from '@angular/router';
import { empty } from 'rxjs';
import { AgentService } from '../services/agent.service';
import { PreRenderService } from '../services/pre-render.service';
import { catchError } from 'rxjs/operators';
import { UrlValidator } from './url-validator';
import { UrlSanitizerService } from '../services/url-sanitizer.service';
var AgentResolver = /** @class */ (function (_super) {
    __extends(AgentResolver, _super);
    function AgentResolver(_agentService, _router, _preRenderService, _urlSanitizerService) {
        var _this = _super.call(this, _urlSanitizerService, _router, _preRenderService) || this;
        _this._agentService = _agentService;
        _this._router = _router;
        _this._preRenderService = _preRenderService;
        _this._urlSanitizerService = _urlSanitizerService;
        return _this;
    }
    AgentResolver.prototype.resolve = function (route, rstate) {
        var _this = this;
        var url = rstate.root.firstChild.url;
        var agentId = '';
        var agentIdRegex = /(-+)(\D?\d+)-ag/;
        var agentIdMatches = agentIdRegex.exec(url[1].path);
        if (agentIdMatches)
            agentId = agentIdMatches[agentIdMatches.length - 1];
        if (!this.isValidUrl(url))
            return empty();
        return this._agentService.getAgentDetails(agentId)
            .pipe(catchError(function (err) {
            _this.navigationRedirect('/find-agent-or-office/agent');
            return empty();
        }));
    };
    return AgentResolver;
}(UrlValidator));
export { AgentResolver };
